import React from "react";
import { inject, observer } from "mobx-react";
import { IAppStore } from "../../../../stores/Interfaces";
import { EDIT_DECLARANT } from "../../../../constants/authorize";
import { Option } from "../../../common/forms/Interfaces";
import Select from "../../columns/select";
import { CHANGE_TABLE_CELL_EVENT } from "../../../../constants/events";

interface Props {
  option: string | number;
  options: Option[];
  entityKey: string;
  entityId: unknown;
  store?: IAppStore;
}

const Mistakes: React.FC<Props> = ({
  option,
  entityKey,
  entityId,
  store,
  options,
}) => {
  if (store?.userStore.authorizeByPermission(EDIT_DECLARANT)) {
    return (
      <Select
        string={option}
        entityKey={entityKey}
        entityId={entityId}
        options={options}
        eventKey={CHANGE_TABLE_CELL_EVENT}
      />
    );
  }

  return <>{option}</>;
};
export default inject("store")(observer(Mistakes));
